import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faLaptopCode } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          {/* ATLAS CLOUD SERVICES INTERNSHIP */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Jul. 2025 - Aug. 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">AI Engineer Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">Atlas Cloud Services | Casablanca, Morocco</h4>
            <p>
              <strong>Project:</strong> ITSM Conversational AI (Proof of Concept).<br/>
              Here, I developed an end-to-end <strong>Proof of Concept (PoC)</strong> for an internal IT support chatbot. I designed a local Retrieval-Augmented Generation (RAG) pipeline to query technical knowledge bases, successfully validating the feasibility of automating IT workflows via LLMs.<br/>
              <br/>
              <em>Tech Stack: Applied GenAI • RAG Architecture • Vector Databases • Python</em>
            </p>
          </VerticalTimelineElement>

          {/* OMDENA PROJECT */}
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Apr 2025 - May 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faLaptopCode} />}
          >
            <h3 className="vertical-timeline-element-title">Junior ML Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">Omdena | Remote (International Team)</h4>
            <p>
              <strong>Project:</strong> Multi-Agent AI for Mental Health Support.<br/>
              Collaborated with a global team to build a complex multi-agent system using <strong>CrewAI</strong>. Implemented intent recognition and contextual memory using <strong>RAG</strong> to deliver tailored well-being advice. Designed a smooth, interactive UI using <strong>Streamlit</strong> for real-time sentiment analysis.<br/>
              <br/>
              <em>Tech Stack: CrewAI • HuggingFace • Gemini 2.0 Flash • LangChain • Streamlit</em>
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>  
  );
}

export default Timeline;
